var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"ypo-auth-page"},[_c('v-flex',[_c('login-card')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }